import { render, staticRenderFns } from "./xwa.vue?vue&type=template&id=d1f10330&"
import script from "./xwa.vue?vue&type=script&lang=js&"
export * from "./xwa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports